export const categoryDetails = [
  {
    name: 'General Knowledge',
    icon: '🧠',
    description: 'A grab bag of classic trivia, quick facts, and everyday stumpers.',
  },
  {
    name: 'Science',
    icon: '🔬',
    description: 'Elements, bodies, forces, and the small wonders hiding in plain sight.',
  },
  {
    name: 'History',
    icon: '🏛️',
    description: 'Dates, discoveries, empires, and moments that changed the map.',
  },
  {
    name: 'Geography',
    icon: '🌍',
    description: 'Capitals, rivers, mountains, oceans, and planet-sized bragging rights.',
  },
  {
    name: 'Nature & Animals',
    icon: '🐾',
    description: 'Wild facts about creatures, habitats, plants, and living systems.',
  },
  {
    name: 'Arts & Culture',
    icon: '🎨',
    description: 'Paintings, books, symbols, and creative landmarks.',
  },
  {
    name: 'Technology',
    icon: '💻',
    description: 'Digital basics, internet ideas, and modern tech vocabulary.',
  },
  {
    name: 'Web Development',
    icon: '🧩',
    description: 'Frontend foundations, React ideas, and web-building knowledge.',
  },
];

export const categories = ['All', ...categoryDetails.map((category) => category.name)];

export const difficulties = ['Any', 'Easy', 'Medium', 'Hard'];

export const questionTypes = ['Any', 'multiple', 'true/false'];
